export const baseURL="https://wtsacademy.dedicateddevelopers.us/api"
export const reg_end_point={
registration:"/user/signup"
}
export const login_end_point={
login:"/user/signin"
}
export const product_post_end_point={
product_post:"/product/create"
}
export const product_list_end_point={
show_product:`/product/list`
}
